
// utils to delay promise
function wait(ms) {
    return (x) => {
        return new Promise(resolve => setTimeout(() => resolve(x), ms));
    };
}

export { wait }

import CryptoJS from 'crypto-js'
import { SECRET_KEY } from './const'

const secretKey = SECRET_KEY.toString();
export function Encrypt(word, keyParam, ivParam) {

    let keyStr = keyParam == null || keyParam === "" ? secretKey : keyParam;

    //key 길이 32byte
    if(keyStr.length < 32) {
        return null;
    }

    let ivStr = ivParam == null || ivParam === "" ? secretKey.substring(0, 16) : ivParam;
    keyStr = keyStr.substring(0, 32);

    let key = CryptoJS.enc.Utf8.parse(keyStr);
    let iv = CryptoJS.enc.Utf8.parse(ivStr);

    let srcs = CryptoJS.enc.Utf8.parse(word);
    var encrypted = CryptoJS.AES.encrypt(word, key, {
        iv: iv
    });

    return CryptoJS.enc.Base64.stringify(encrypted.ciphertext);
}
 

export function Decrypt(word, keyStr, ivStr) {
    let key = KEY
    let iv = IV
 
    if (keyStr) {
        key = CryptoJS.enc.Utf8.parse(keyStr);
        iv = CryptoJS.enc.Utf8.parse(ivStr);
    }
 
    let base64 = CryptoJS.enc.Base64.parse(word);
    let src = CryptoJS.enc.Base64.stringify(base64);
 
    var decrypt = CryptoJS.AES.decrypt(src, key, {
        iv: iv
    });
 
    var decryptedStr = decrypt.toString(CryptoJS.enc.Utf8);
    return decryptedStr.toString();
}
